<template>
  <div>
    <BaseTitle :title="$t('content.quiz_stastiktik')" />
    <div>
      <v-card class="mb-7">
        <div class="pa-5">
          <h3 class="high">{{ $t('content.quiz_summary') }}</h3>
          <div class="assignment-detail-desc d-flex justify-center mt-7">
            <v-row>
              <v-col md="3">
                <div>
                  <span class="d-block average-score">{{ $t('content.average_score') }}</span>
                  <strong class="high" v-if="datas.averageScore === 0">0</strong>
                  <strong class="high" v-else> {{ datas.averageScore }}%</strong>
                </div>
              </v-col>
              <v-col md="3">
                <div>
                  <span class="d-block average-score">{{ $t('content.high_score') }}</span>
                  <strong class="high" v-if="datas.highScore === 0"> 0</strong>
                  <strong class="high" v-else> {{ datas.highScore }}%</strong>
                </div>
              </v-col>
              <v-col md="3">
                <div>
                  <span class="d-block average-score">{{ $t('content.low_score') }}</span>
                  <strong class="high" v-if="datas.lowScore === 0"> 0</strong>
                  <strong class="high" v-else> {{ datas.lowScore }}%</strong>
                </div>
              </v-col>
              <v-col md="3">
                <div>
                  <span class="d-block average-score">{{ $t('content.standar_deviation') }}</span>
                  <strong class="high" v-if="datas.standardDeviation === 'NaN' || datas.standardDeviation === 0">0</strong>
                  <strong class="high" v-else> {{ datas.standardDeviation }}</strong>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="d-flex align-center justify-center">
            <chart width="800" height="400" type="bar" :options="chartOptions" :series="series" />
          </div>
          <!-- <chart type="radar" ref="radarchart" width="800" height="400" :options="chartOptionsTest" :series="seri"></chart>
          <v-btn color="primary" class="btn-primary-custom mt-3 ml-10" outlined @click="downloadURI()">{{ $t('content.export') }}</v-btn> -->
        </div>
      </v-card>

      <v-card v-if="quizlength >= 1" shaped class="pa-3" style="width:240px;">
        <h3 class="high">{{ $t('content.quiz_break') }}</h3>
      </v-card>
      <v-card class="mb-5 mt-5" v-for="(quiz, idx) in datas.quizQuestions" :key="idx">
        <slide-box :value="true">
          <template #activator="{isOpen}">
            <div class="pa-5 d-flex justiy-space-between align-items section-header active">
              <div class="student-title">
                <article v-html="quiz.quizQuestion" />
              </div>
              <v-spacer />
              <v-icon class="app-menu-indicator">{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
            </div>
          </template>
          <v-divider />
          <template>
            <div class="assignment-content">
              <strong class="attempts-text"
                >{{ $t('content.attempt') }}: {{ quiz.totalRespondentAttempt }} {{ $t('content.out_of') }} {{ quiz.totalRespondent }}</strong
              >
              <v-row>
                <v-col md="11">
                  <v-data-table hide-default-footer :headers="headersGrup" :items="quiz.quizAnswers" :loading="loading" class="table-custom mt-5">
                    <template v-slot:item.answerRespondent="{ item }">
                      <span>{{ item.answerRespondent }} {{ $t('content.respondent') }}</span>
                    </template>
                    <template v-slot:item.answerPercentage="{ item }">
                      <span>{{ item.answerPercentage }} %</span>
                    </template>
                    <template v-slot:item.answer="{ item }">
                      <span v-if="item.correctAnswer === true" class="green--text">{{ item.answer }}</span>
                      <span v-if="item.correctAnswer === false">{{ item.answer }}</span>
                    </template>
                    <template #no-data>
                      {{ $t('data_not_available') }}
                    </template>
                  </v-data-table>
                </v-col>
                <v-col class="1">
                  <chart type="pie" width="600" height="300" :options="persenOps" :series="quiz.percentages" />
                </v-col>
              </v-row>
            </div>
          </template>
        </slide-box>
      </v-card>

      <!-- <v-card class="mb-5 mt-5">
        <slide-box :value="true">
          <template #activator="{isOpen}">
            <div class="pa-5 d-flex justiy-space-between align-items section-header active">
              <div class="student-title">Definisi bakteri adalah</div>
              <v-spacer />
              <v-icon class="app-menu-indicator">{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
            </div>
          </template>
          <v-divider />
          <template>
            <div class="assignment-content">
              <strong class="attempts-text">Attempts: 135 out of 135</strong>
              <v-row>
                <v-col md="8">
                  <v-data-table hide-default-footer :headers="headersGrup" :items="groups" :loading="loading" class="table-custom mt-5">
                    <template #no-data>
                      {{ $t('data_not_available') }}
                    </template>
                  </v-data-table>
                </v-col>
                <v-col class="4">
                  <chart type="pie" width="380" :options="persenOps" :series="persen" />
                </v-col>
              </v-row>
            </div>
          </template>
        </slide-box>
      </v-card> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import Chart from 'vue-apexcharts';
import SlideBox from '@/components/SlideBox';
// import { jsPDF } from 'jspdf';

export default {
  name: 'TeacherQuizStats',
  components: {
    BaseTitle,
    Chart,
    SlideBox
  },
  computed: {
    ...mapGetters({
      user: 'Auth/user'
    }),
    headersGrup() {
      return [
        { text: this.$t('question.answer'), value: 'answer' },
        { text: this.$t('content.respondent'), value: 'answerRespondent' },
        { text: this.$t('content.percentage'), value: 'answerPercentage' }
      ];
    },
    quizlength() {
      return this.datas.quizQuestions?.length;
    }
  },
  data: () => ({
    datas: '',
    persenOps: {
      yaxis: {
        labels: {
          formatter: function(value) {
            return value + '%';
          }
        }
      },
      colors: ['rgb(0, 143, 251)', '#f39c12'],
      dataLabels: {
        style: {
          fontSize: '14px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 'bold',
          colors: ['rgb(0, 143, 251)', '#f39c12']
        },
        background: {
          enabled: true,
          foreColor: '#fff',
          padding: 4,
          borderRadius: 10,
          borderWidth: 1,
          borderColor: '#fff',
          opacity: 0.9
        },
        formatter: function(value, { seriesIndex, w }) {
          if (seriesIndex === 0) {
            return w.config.labels[0] + ' : ' + value + '%';
          } else if (seriesIndex === 1) {
            return w.config.labels[1] + ' : ' + value + '%';
          }
        }
      },
      // labels: ['Answer Corrent', 'Answer Incorrect'],
      fill: {
        colors: ['rgb(0, 143, 251)', '#f39c12']
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }
      ]
    },
    loading: false,
    chartOptions: {
      chart: {
        type: 'bar'
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        min: 0,
        max: ''
      },
      yaxis: {
        max: ''
      },
      fill: {
        opacity: 1
      }
    },
    series: []
  }),
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler() {
        this.getData();

        this.datas.quizQuestions = null;
        this.persenOps.labels = [this.$t('content.answer_correct'), this.$t('content.answer_incorrect')];
      }
    }
  },
  methods: {
    getData() {
      this.persenOps.labels = [this.$t('content.answer_correct'), this.$t('content.answer_incorrect')];

      this.$store
        .dispatch('Question/fetchListStat', this.$route.params.id)
        .then(res => {
          for (let i = 0; i < res.chart.data.length; i++) {
            res.chart.data[i] = [i, res.chart.data[i]];
          }
          var data = [
            {
              name: res.chart.name,
              data: res.chart.data
            }
          ];
          var categories = {
            categories: res.chart.categories
          };
          this.chartOptions.xaxis = categories;
          this.chartOptions.xaxis.max = res.max;
          this.series = data;
          this.datas = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    }
    // downloadURI() {
    //   this.$refs.radarchart.chart.dataURI().then(uri => {
    //     console.log(uri.imgURI);
    //     const doc = new jsPDF();

    //     doc.setFontSize(40);
    //     doc.text(30, 20, 'Hello world!');
    //     doc.addImage(uri.imgURI, 'png', 15, 40, 180, 100);
    //     doc.save('Hasil_rekap.pdf');
    //   });
    // }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.average-score {
  color: #acacac;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 14px;
}
.high {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 24px;
  line-height: 29px;
  text-align: left;
}
.assignment-detail {
  &-title {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #acacac;
  }

  &-icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    box-sizing: border-box;
    text-align: center;
    margin-right: 16px;

    svg {
      transform: scale(1.6);
      margin-top: 15px;
    }
  }

  &-desc {
    line-height: 1.8em;
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
}

.assignment {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-content {
    margin: 10px 20px 20px 20px;

    font-size: 12px;
  }
}
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #ffffff;
    .student-title {
      color: #6d6d6d;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.attempts-text {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
</style>
